import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const PlatformObservabilityContext = createContext(undefined);
export const PlatformObservabilityProvider = ({ value, children }) => (_jsx(PlatformObservabilityContext.Provider, { value: value, children: children }));
export function usePlatformObservability() {
    const ctx = useContext(PlatformObservabilityContext);
    if (!ctx) {
        throw new Error("usePlatformObservability must be used within a PlatformObservabilityProvider");
    }
    return ctx;
}
